<template>
  <v-menu open-on-hover transition="slide-x-transition"  offset-y>
    <template v-slot:activator="{ on, attrs }">
        <v-btn icon large v-bind="attrs" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
        </v-btn>
    </template>
    <v-card class="mx-auto" max-width="300" tile>
        <v-list v-if="user != null">
            <v-subheader>{{ user.login }}</v-subheader>
            <v-list-item-group >
                <v-list-item @click="profil()">
                    <v-list-item-action>
                        <v-icon>mdi-tooltip-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-action>
                        <v-list-item-title>{{$t('menu.user.profile')}}</v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="badge()">
                    <v-list-item-action>
                        <v-icon>mdi-police-badge</v-icon>
                    </v-list-item-action>
                    <v-list-item-action>
                        <v-list-item-title>{{$t('menu.user.mybadge')}}</v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="notificationSubscriber()">
                    <v-list-item-action>
                        <v-icon>mdi-bell-plus</v-icon>
                    </v-list-item-action>
                    <v-list-item-action>
                        <v-list-item-title>{{$t('menu.user.notificationsubscriber')}}</v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="deconnect()">
                    <v-list-item-action>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-action>
                        <v-list-item-title>{{$t('menu.user.logout')}}</v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
            </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
</template>

<script>

import { mapActions,mapState,mapGetters } from 'vuex';
import NotificationMixin from '../../mixins/NotificationMixin';
export default {
  name: 'ProfilNavigation',
  servicePrefix: 'user',
  mixins: [NotificationMixin],
  props: {

  },
  data: () => ({
    userProfil: null,
  }),

  methods: {
    ...mapActions({
      userPushAction: 'user/action',
      userGetData: 'user/data'
    }),
    profil() {
      console.log('profil');
      this.$router.push({ name: `Profil` });
    },
    badge() {
      console.log('badge');
      this.$router.push({ name: `MyBadge` });
    },
    deconnect() {
      this.userPushAction({action: 'logout',values: {}});
      console.log(this.action);
    },
    notificationSubscriber() {
      console.log('notificationsubscriber');
      this.$router.push({ name: `NotificationSubscriber` });
    },
    deconnected() {
      this.$root.isConnected = false;
      this.$root.passwordTurnover = false;
      this.$router.push({ name: `Login` });
      console.log("deconnected");
    },
  },
  mounted() {
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.user = this.dataUser('profil');
    }
  },
  computed: {
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    user: {
      get() { return this.userProfil },
       set(value) { this.userProfil = value; }
    }
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      console.log(this.action);
      if (this.action == 'logout') {
        this.deconnected(actioned);
      }
    },
    updatedata: function (updatedata) {
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
      }
    },
    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    }
  }
};
</script>
